import { createComponent } from '@mtfe/sweet';
import { eventBus, dom, lazyLoadImg } from '@mtfe/sweet-utils';
import { scrollLoading, oadLX } from '@mtfe/sweet-oad';

import style from './style.less';
import tpl from './dom.html';
import {
    fetchDataList,
    createPoiListDom,
    renderPoi,
    renderPoiWithCoupon,
    getOnClickEventName,
} from '../../../utils/index';
import http from '../../../service/index';
import store from '../../../store/index';

const scrollLoadingApply = 'b_waimai_u1an50iv_mv';
const { storeCommon, storeCoupon } = store;
const { storeOptionalWelfare } = storeCoupon;
const { startImgListener } = lazyLoadImg;

const InnerPoi = (props = {}) => {
    const { listInfo, isOpenAutoLoading = true } = props;
    const { recallBizId, poiContainerID, bottomTipID } = listInfo;

    const data = {
        poiContainerID,
        bottomTipID,
    };
    const renderFunc = storeOptionalWelfare.isWelfare(recallBizId) ? renderPoiWithCoupon : renderPoi;

    const onClickEventName = getOnClickEventName(recallBizId);
    eventBus.$on(onClickEventName, async () => {
        if (storeCommon.isLoading) {
            return;
        }
        try {
            const { poiList, pageNo } = listInfo;
            const listDom = dom.$id(poiContainerID);

            if (pageNo === 1) {
                const poiInfo = await fetchDataList({ listInfo });
                poiList.push(...poiInfo);
            }
            listDom.innerHTML = createPoiListDom(poiList, recallBizId);

            const { scrollLoadingInit, setEnding } = scrollLoading({
                dataList: poiList,
                reportObserve: http.gMonitorApi,
                renderItem: (poiInfo, itemIndex) => {
                    const res = renderFunc(poiInfo, itemIndex, recallBizId);
                    return res;
                },
                fetchDataList: async () => {
                    const res = await fetchDataList({ listInfo });
                    return res;
                },
                listContainerID: poiContainerID,
                bottomTipID,
            });
            if (poiList.length === 0) {
                setEnding();
            } else if (!isOpenAutoLoading) {
                scrollLoadingInit();
                setEnding();
            } else {
                // 滚动加载执行
                oadLX.mv(scrollLoadingApply);
                scrollLoadingInit();
            }
            startImgListener();
        } catch (error) {
            console.error(error);
        }
    });

    const events = {};
    const component = createComponent(tpl, { data, style }, events);
    return component;
};
export default InnerPoi;
